import { ConstantVariables } from "./ConstantVariables";

export class StringHelper {

    public static stringToFloat(string : string | undefined) : number | undefined {
        if(string === undefined) return undefined;

        var lastIndexOfPeriod = string.lastIndexOf('.');
        var lastIndexOfComma = string.lastIndexOf(',');

        if(lastIndexOfComma > lastIndexOfPeriod) {
            string = string.replace(/\./g,'');            
        }
        else {
            string = string.replace(/\,/g,'');
            string = string.replace(/\./g,',');
        }
        
        if(string.indexOf(',') < 0) return parseFloat(string);
        const numArr = string.split(',');
        return parseFloat( numArr.reduce((a, v, i) => a + ((i === numArr.length - 1) ? `.${v}` : v), '') ); 
    }

    public static bindNumberStringInputs() {
        $('input[data-number-input-type]').each((index, element) => {
            var numberInput = $(element);

            numberInput.off('change').on('change', () => {
                var parsedNumber = this.stringToFloat(numberInput.val()?.toString());
                if(parsedNumber == undefined|| isNaN(parsedNumber)) {
                    parsedNumber = 0.00;
                }
                numberInput.val(parsedNumber.toLocaleString(ConstantVariables.DefaultCulture, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }));
            })
        })
    }

    public static convertLetterToNumber(str) {
        const start = 96 // "a".charCodeAt(0) - 1
        const len = str.length;
        const out = [...str.toLowerCase()].reduce((out, char, pos) => {
            const val = char.charCodeAt(0) - start
            const pow = Math.pow(26, len - pos - 1);
            return out + val * pow
        }, 0)
        
        return out;
    }
}